// extracted by mini-css-extract-plugin
module.exports = {"button":"f562","defaultButton":"_91b3","title":"beed","bigTitle":"d414","subTitle":"_7c6e","messageText":"_1e28","center":"_7a9e","link":"ff05","error":"ac65","line":"_6289"};